import { useQuery } from "@tanstack/react-query";
import { plansApi, type Plan } from "@/api/plans-api";

export function usePlans() {
  const { data, isLoading, error } = useQuery<Plan[]>({
    queryKey: ["billingPlans"],
    queryFn: () => plansApi.listPlans(),
    staleTime: 10 * 60 * 1000,
  });

  return {
    plans: data ?? [],
    isLoading,
    error,
  };
}
